import { useMemo } from 'react';
import { Facet } from './Facet/Facet';
import clsx from 'clsx';

function filterAndSortFacets(facets) {
    const filteredFacets = facets.filter((facet) => {
        return facet.visible && ['checkbox', 'radio', 'link'].includes(facet.type);
    });
    filteredFacets.sort((facet) => (facet.type === 'link' ? -1 : +1));

    return filteredFacets;
}

export function FacetsLeft({
    facets,
    facetTrigger,
    toggleFacetTrigger,
    onFacetChange,
    totalResults,
    resourcedTexts,
}) {
    const filteredFacets = useMemo(() => filterAndSortFacets(facets), [facets]);

    return (
        <div className={clsx('sfr-facets-left', facetTrigger && 'is-active')}>
            <div className="sfr-facets-left__wrapper">
                <div className="sfr-facets-left__group-wrapper">
                    <div className="sfr-facets-left__group-scroll">
                        {filteredFacets.map((facet) => (
                            <Facet
                                key={facet.facetId}
                                {...facet}
                                onFacetChange={onFacetChange}
                                resourcedTexts={resourcedTexts}
                            />
                        ))}
                    </div>

                    <div className="sfr-facets-left__bottom">
                        <button
                            type="button"
                            className="sfr-facets-left__mobile-filter-btn button primary"
                            onClick={(event) => toggleFacetTrigger(event)}
                        >
                            {resourcedTexts.mobileFilterShow}
                            &nbsp;<strong>{totalResults}</strong>&nbsp;
                            {resourcedTexts.mobileFilterResults}
                        </button>

                        <button
                            type="button"
                            className="sfr-facets-left__mobile-close-btn"
                            onClick={(event) => toggleFacetTrigger(event)}
                        >
                            <span className="visually-hidden">{resourcedTexts.closeFilter}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
